import auditService from 'resources/audit/audit.service';
import commentService from 'resources/comment/comment.service';
import { AUDIT_STATUSES } from 'resources/audit/audit.constants';

export const completeAudit = async ({ auditId }) => {
  const [updatedAudit] = await Promise.all([
    auditService.updateAudit({
      id: auditId,
      status: AUDIT_STATUSES.COMPLETED_SUCCESS,
    }),
    commentService.resolveAuditComments({ auditId }),
  ]);

  return updatedAudit;
};
